import React from 'react';
import PropTypes from 'prop-types';
import Currency from '../../Currency';

const CellDisplay = ({ price, children }) => (
  <div>
    {price
      ? <Currency trailingZero>{children * 100}</Currency>
      : children
    }
  </div>
);

CellDisplay.defaultProps = {
  price: false,
}

CellDisplay.propTypes = {
  price: PropTypes.bool,
  children: PropTypes.any,
}

export default CellDisplay;
